import { moimAPI } from ".";

export async function getPositionsBatch(positions: Moim.Id[]) {
  return (
    await moimAPI.request<
      Promise<Moim.IPaginatedListResponse<Moim.Position.IPosition>>
    >({
      method: "POST",
      data: { positions },
      url: `/positions/_batch`,
    })
  ).data;
}
